<div class="panel marginB0">
  <div *ngIf="panelTitle" class="panel-title">
    <img *ngIf="panelTitleIcon" class="icon-title" [src]="panelTitleIcon" [alt]="panelTitleIconAlt">
    <h2>
      <small>{{panelTitleSmall}}</small>{{panelTitle}}</h2>
  </div>
  <div [ngClass]="{'content': padding === 'padding'}">
    <ng-content></ng-content>

    <div *ngIf="loading" class="row loader">
      <div class="col-xs-12">
        <span class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></span>
        <span class="loader-info">Carregando dados...</span>
      </div>
    </div>

    <div class="no-data" *ngIf="noData && !loading">
      <h3>{{noDataText}}</h3>
    </div>
  </div>
</div>